/**
 * Per-chunk upload state (`ChunkStatus`).
 *
 * Extracted from `src/utils/chunkAudioRecorder.ts` with the session type
 * closure (OpenSpec `monorepo-session-data-core` C2) — the discovered closure
 * gap: `QuerySessionResponse.chunksUploading` is typed by this enum, and the
 * recorder module can never be package-importable (it value-imports posthog
 * and the offline recorder). Same treatment as `StreamingStatus`: the leaf
 * vocabulary moves, `chunkAudioRecorder.ts` re-exports it, and enum identity
 * is preserved for every existing importer.
 *
 * The recorder machinery itself is capture material and stays put (design
 * D2a) — this file carries only the vocabulary the session cache entry
 * speaks.
 */
export enum ChunkStatus {
  QUEUED = 'QUEUED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
